import React from "react";
import CartContext from "./cart-context";
import { useReducer } from "react";

const defaultCartState = {
    items:[]
}

const cartReducer = (state, action) => {
    console.log('action.type');
    console.log(action.type);
    if(action.type === 'ADD'){
        const updatedItems = state.items.concat(action.item);
        
        return{
            items:updatedItems
        }

    } 

    if(action.type === 'REMOVE'){
        // alert(action.id)
        // const existingCartItemIndex = state.item.findIndex(
        //     (item) => item.id === action.id
        // );
        // const existingItem = state.items[existingCartItemIndex]

        let updatedItems = state.items.filter(
            item => item.id !== action.id
        )

        return {
            items:updatedItems
        }
    }
    return defaultCartState;
}

const CartProvider = (props) => {

    const [cartState, dispatchCartAction] = useReducer(cartReducer, defaultCartState)

    const addItemToCartHandler = (item) => {
        dispatchCartAction({type:'ADD', item:item})
    };
    const removeItemToCartHandler = (id) => {
        dispatchCartAction({type:'REMOVE', id:id})
    };

    const cartContext = {
        items:cartState.items,
        additem:addItemToCartHandler,
        removeItem:removeItemToCartHandler
    }
return <CartContext.Provider value={cartContext}>
{props.children}
</CartContext.Provider>
}

export default CartProvider;